export { default } from './ExternalLinkAlert';
